export const types = {
  GET_PRODUCTS_REQUEST: "GET_PRODUCTS_REQUEST",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAIL: "GET_PRODUCTS_FAIL",

  CREATE_ORDER_REQUEST: "CREATE_ORDER_REQUEST",
  CREATE_ORDER_SUCCESS: "CREATE_ORDER_SUCCESS",
  CREATE_ORDER_FAIL: "CREATE_ORDER_FAIL",

  CAPTURE_ORDER_REQUEST: "CAPTURE_ORDER_REQUEST",
  CAPTURE_ORDER_SUCCESS: "CAPTURE_ORDER_SUCCESS",
  CAPTURE_ORDER_FAIL: "CAPTURE_ORDER_FAIL",

  SELECT_PRODUCT: "SELECT_PRODUCT",
  CLEAR_SELECTED_PRODUCT: "CLEAR_SELECTED_PRODUCT",
};
